import gql from 'graphql-tag';

export const DeleteIncidentCategory = gql`
  mutation DeleteIncidentCategory($organizationId: ID!, $categoryId: ID!) {
    deleteIncidentCategory(organizationId: $organizationId, categoryId: $categoryId) {
      id
    }
  }
`;
